import { map } from 'lodash';
import React from 'react';

type CarouselViewProps<T> = {
  items: T[];
  activeIndex?: number;
  itemVew: (item: T) => React.ReactNode;
  captionVew?: (item: T) => React.ReactNode;
  indicatorPosition?: number;
  indicateBackground?: string;
};

export const CarouselView = <T,>({
  items,
  activeIndex,
  itemVew,
  captionVew,
  indicatorPosition,
  indicateBackground,
}: CarouselViewProps<T>) => {
  const CarouselIndicator = () => {
    return (
      <ol
        className="carousel-indicators"
        style={{ top: indicatorPosition ?? 20, height: 20 }}
      >
        {map(items, (item, index) => {
          return (
            <li
              style={{ background: indicateBackground ?? '' }}
              data-target="#carousel-view-list"
              data-slide-to={index}
              className={index === (activeIndex ?? 0) ? 'active' : ''}
              key={index}
            />
          );
        })}
      </ol>
    );
  };

  const CarouselItems = () => {
    return (
      <div className="carousel-inner">
        {map(items, (item, index) => {
          return (
            <div
              className={`item ${index === (activeIndex ?? 0) ? 'active' : ''}`}
              key={index}
            >
              {itemVew(item)}
              <div className="carousel-caption">{captionVew?.(item)}</div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <ul>
      <div
        id="carousel-view-list"
        className="carousel slide"
        data-ride="carousel"
      >
        <CarouselIndicator />
        <CarouselItems />
      </div>
    </ul>
  );
};
